<ion-header class="full-page-only" [class.show_premium]="show_premium">
  <ion-toolbar>
    <ion-buttons slot="start" class="logo">
      <img class="main-img" src="assets/Skutt-Original-Horizontal-Logo_PMS-167_RegisteredTMWhiteSun.png"/>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding has-header home-page" [class.show_premium]="show_premium">
  <ion-img [src]="logoUrl" class="login-logo"></ion-img>
  <ion-list id="login-list">
    <ion-item id="login-username-item" name="email" (click)="focusInput('email')">
      <ion-label position="stacked">{{ 'HOME.EMAIL' | translate }}<sup>{{ 'HOME.REQUIRED_FIELD' | translate }}</sup></ion-label>
      <ion-input id="email" name="username" type="email" inputmode="email" autocomplete="username" [(ngModel)]="loginEmail"></ion-input>
    </ion-item>
    <ion-item id="login-password-item" name="password" (click)="focusInput('password')">
      <ion-label position="stacked">{{ 'HOME.PASSWORD' | translate }}<sup>{{ 'HOME.REQUIRED_FIELD' | translate }}</sup></ion-label>
      <app-show-hide-password>
        <ion-input id="password" name="password" type="password" autocomplete="current-password" [(ngModel)]="loginPassword"></ion-input>
      </app-show-hide-password>
    </ion-item>
    <ion-item id="login-remember-item" >
      <ion-label>{{ 'HOME.REMEMBER_ME' | translate }}</ion-label>
      <ion-toggle slot="end" name="rememberMe" [(ngModel)]="loginRemember" (ionChange)="onRememberMeChange($event)"></ion-toggle>
    </ion-item>
  </ion-list>
  <div id="login-markdown3" *ngIf="errorText" class="login-error error-box" role="alert"
     [class.show_premium]="show_premium">
    <p>{{ errorText }}</p>
  </div>
  <div class="login" [class.disabled]="isLoggingIn"
    [class.show_premium]="show_premium">
    <ion-button type="submit" expand="block" size="large" class="login-action-btn"
      color="primary"
      [disabled]="isLoggingIn"
      (click)="loginClick()">
      <span *ngIf="!isLoggingIn">{{ 'HOME.SIGN_IN' | translate }}</span>
      <ion-spinner name="bubbles" *ngIf="isLoggingIn"></ion-spinner>
    </ion-button>
    <ion-button expand="block" size="large" class="login-action-btn"
      color="medium"
      [disabled]="isLoggingIn"
      (click)="createUser()">
      {{ 'HOME.NEW_USER_SIGN_UP' | translate }}
    </ion-button>
    <ion-button expand="block" size="large" class="login-action-btn" *ngIf="isLoggingIn" (click)="cancelLogin()">
      <span>{{ 'HOME.CANCEL_LOGIN' | translate }}</span>
    </ion-button>

    <div id="login-secondary-links" [class.show_premium]="show_premium">
      <a (click)="forgotPassword()">{{ 'HOME.FORGOT_PASSWORD' | translate }}</a>
      <a *ngIf="show_premium" (click)="recoverEmail()">{{ 'HOME.RECOVER_EMAIL_LINK' | translate }}</a>
      <a (click)="confirmAccount()">{{ 'HOME.CONFIRM_ACCOUNT_LINK' | translate }}</a>
      <a (click)="presentWhatIsKilnLink()">{{ 'LANDING.WHAT_IS_KILNLINK' | translate }}</a>
    </div>
  </div>

  <div id="login-hint">
    <div><ion-icon name="alert"></ion-icon>&nbsp;{{ 'HOME.EMAIL_CASE_SENSITIVE' | translate }}</div>
  </div>
</ion-content>

<ion-modal
  [isOpen]="whatIsKilnLinkOpen"
  (didDismiss)="whatIsKilnLinkOpen = false"
  class="what-is-kilnlink-modal">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>{{ 'LANDING.WHAT_IS_KILNLINK' | translate }}</ion-title>
        <ion-buttons slot="end">
          <ion-button fill="clear" (click)="closeWhatIsKilnLink()">{{ 'LANDING.WHAT_IS_KILNLINK_DONE' | translate }}</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding what-is-kilnlink-content">
      <p class="what-is-kilnlink-intro">{{ 'LANDING.WHAT_IS_KILNLINK_INTRO' | translate }}</p>
      <ul class="what-is-kilnlink-list">
        <li *ngFor="let bullet of whatIsKilnLinkBullets">{{ bullet }}</li>
      </ul>
      <ion-button expand="block" class="what-is-kilnlink-dismiss" (click)="closeWhatIsKilnLink()">
        {{ 'LANDING.WHAT_IS_KILNLINK_DONE' | translate }}
      </ion-button>
    </ion-content>
  </ng-template>
</ion-modal>
